import { removeEmptyEntries } from '..';
import tracker from './TrackingService';

const GROUP_TYPE = 'reviews';

export const reportEvent = (type, eventData) => {
    const { itemsCount, origin, filterType, reason } = eventData;

    tracker.sendBQEvent({
        type,
        reason,
        group: GROUP_TYPE,
        page: {
            name: origin,
            element: {
                type: 'reviews_filter',
                text: filterType,
                items_count: itemsCount,
            },
        },
    });
};

export const getBQClickFields = ({
    type,
    text,
    elementName,
    elementType = 'text',
    elementMetadata,
    componentName,
}) => ({
    type,
    out_of_sessions: false,
    domain: {
        name: 'quality',
    },
    publisher: {
        domain: 'algos',
        sub_domain: 'quality',
    },
    sub_group: 'website_actions',
    group: 'user_actions',
    action: {
        type: 'click',
    },
    page: {
        element: removeEmptyEntries({
            name: elementName,
            type: elementType,
            text,
            metadata: typeof elementMetadata === 'object' ? JSON.stringify(elementMetadata) : elementMetadata,
        }),
        component: {
            name: componentName,
        },
    },
});

export const TYPES = {
    workSampleHover: {
        BigQuery: 'hovered_on_reviews_work_sample',
        Mixpanel: 'Hovered Review Work Sample',
    },
    workSampleClick: {
        BigQuery: 'clicked_on_reviews_work_sample',
        Mixpanel: 'Clicked Review Work Sample',
    },
};
